import React from "react";
import { ExternalLink } from "lucide-react";

export default function CraftBoltBanner({ variant = "default", message }) {
  return (
    <a
      href="https://www.craftbolt.cz"
      target="_blank"
      rel="noopener noreferrer"
      className="stb-card block p-5 relative no-underline group hover:border-[#FF6B00]"
      data-testid="craftbolt-banner"
    >
      <span className="stb-rivet" style={{ top: 6, left: 6 }} />
      <span className="stb-rivet" style={{ top: 6, right: 6 }} />
      <span className="stb-rivet" style={{ bottom: 6, left: 6 }} />
      <span className="stb-rivet" style={{ bottom: 6, right: 6 }} />
      <div className="flex flex-col gap-3">
        <div>
          <img
            src="/craftbolt-logo.svg"
            alt="CraftBolt"
            className="h-9 w-auto transition-transform duration-200 group-hover:scale-105"
            data-testid="craftbolt-banner-logo"
          />
        </div>
        <div>
          <span className="stb-label text-[#FF6B00]">PARTNER</span>
          <p className="stb-h text-base md:text-lg mt-1 leading-tight">
            {message ||
              "Potřebuješ tento materiál dovézt nebo zabudovat? Najdi si řemeslníka na CraftBolt."}
          </p>
        </div>
        <span className="stb-btn stb-btn-primary w-full justify-center group-hover:translate-x-0.5">
          Najít řemeslníka <ExternalLink size={14} />
        </span>
      </div>
    </a>
  );
}
